<template>
    <div>
        <transition :name="transition" mode="out-in">
            <router-view/>
        </transition>
        
    </div>
</template>

<script>
export default {
    name: 'Content',
    data() {
        return {
            transition: 'hpt'
        }
    },
    created() {
        this.$router.beforeEach((to, from, next) => {
            this.$data.transition = to.meta.order < from.meta.order ? 'slide-right' : 'slide-left'
            next()
        })
    }
}
</script>

<style>
.hpt-enter-active, .hpt-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
    overflow: hidden;
 }

.hpt-enter, .hpt-leave-active {
    opacity: 0
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition-duration: 0.5s;
  transition-property: height, opacity, transform;
  transition-timing-function: cubic-bezier(0.55, 0, 0.1, 1);
  overflow: hidden;
}

.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  transform: translate(2em, 0);
}

.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  transform: translate(-2em, 0);
}
</style>
